'use strict'

define ['./footer.scss'], () ->
  (RentappService, $state) ->
    restrict: "E"
    template: require("./footer.jade")
    link: (scope, element, attrs) ->
      
      scope.error_states = [
        "root.home.403", 
        "root.home.404"
      ]
        
      scope.$watch(() ->
        $state.$current.name
      , (newVal, oldVal) ->
        scope.current_state = $state.$current.name
        if scope.current_state in scope.error_states
          scope.error_page = true
        else
          scope.error_page = false
      )



// WEBPACK FOOTER //
// ./directives/footer/footer.coffee